import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

export default function ServiceCard({ service, onOpenConsultation }) {
  return (
    <div className="group bg-white rounded-2xl border border-[#D9E8E5] overflow-hidden shadow-card hover:shadow-elevated transition-all duration-300 flex flex-col justify-between hover:-translate-y-1">
      <div>
        {/* Image banner with clean tag */}
        <div className="relative h-64 sm:h-72 overflow-hidden bg-[#123B5D]">
          <img
            src={service.image}
            alt={service.title}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#123B5D]/90 via-[#123B5D]/20 to-transparent"></div>
          
          <div className="absolute top-4 left-4">
            <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-[#F5FAF9] text-[#0F766E] backdrop-blur-sm shadow-sm">
              {service.tag}
            </span>
          </div>

          <div className="absolute bottom-4 left-4 right-4">
            <h3 className="font-serif text-xl sm:text-2xl text-white font-normal leading-snug">
              {service.title}
            </h3>
          </div>
        </div>

        {/* Card Body */}
        <div className="p-6">
          <p className="text-sm text-[#64748B] leading-relaxed">
            {service.shortDescription}
          </p>
        </div>
      </div>

      {/* Card Footer */}
      <div className="p-6 pt-0 mt-auto flex items-center justify-between border-t border-[#D9E8E5] pt-4">
        <Link
          to={`/services/${service.slug}`}
          className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#0F766E] hover:text-[#123B5D] transition-colors group/link"
        >
          <span>Detailed Clinical Pathway</span>
          <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-200 group-hover/link:translate-x-0.5 group-hover/link:-translate-y-0.5" />
        </Link>

        {onOpenConsultation && (
          <button
            onClick={onOpenConsultation}
            className="text-xs font-medium text-[#64748B] hover:text-[#0F766E] underline underline-offset-2"
          >
            Enquire
          </button>
        )}
      </div>
    </div>
  );
}
